<template>
  <div class="main-wrapper">
    <v-container>
      <router-view />
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'DocketwiseHome',
}
</script>
